export const WALLET_LIST = 'WALLET_LIST';
export const WALLET_UPDATE = 'WALLET_UPDATE';
export const DEPOSIT_LIST = 'DEPOSIT_LIST';
export const DEPOSIT_STORE = 'DEPOSIT_STORE';
export const DEPOSIT_UPDATE = 'DEPOSIT_UPDATE';
export const WITHDRAWAL_LIST = 'WITHDRAWAL_LIST';
export const WITHDRAWAL_STORE = 'DWITHDRAWAL_STORE';
export const WITHDRAWAL_UPDATE = 'WITHDRAWAL_UPDATE';
export const FIAT_DEPOSIT_LIST = 'FIAT_DEPOSIT_LIST';
export const FIAT_WITHDRAWAL_LIST = 'FIAT_WITHDRAWAL_LIST';
